import React from "react";
export function Logo({ size = "text-xl", showTagline = false, compact = false }) {
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="bnb-logo">
      <div className="shrink-0 rounded-lg bg-white p-1 border border-c" style={{boxShadow:"0 2px 10px rgba(0,0,0,.15)"}}>
        <img src="/bnb-logo.svg" alt="Bits & Bytes Computer Institute logo" className={compact ? "h-7 w-7" : "h-9 w-9"}/>
      </div>
      {!compact && <div className="leading-none"><span className={`brand-script font-bold ${size} text-t`}>Bits &amp; Bytes</span>{showTagline && <div className="text-[10px] tracking-[0.22em] uppercase text-primary-c mt-1 font-semibold">Training for Change</div>}</div>}
    </div>
  );
}
